import i18n from '@/i18n/index';

export default () => ({
  blocked: 0,
  countryId: 0,
  flow: null,
  useTrafficLoss: false,
  usePostback: false,
  trafficSource: {
    name:i18n.vm.t('None'),
    id: ''
  },
  trackingDomainId: '',
  conversionNotificationUrl: '',
  redirectDomainId: '',
  costModel: 'auto',
  costValue: 0,
  maxCostEnabled: false,
  maxCostUsd: null,
  maxCostAction: 1,
  maxCostBotOfferId: null,
  destinationType: 'flow',
  currencyId: 'USD',
  redirectMode: '302',
  status: 'active',
  enableSixthSense: 0,
  uniquenessPeriod: 86400,
  workspaceId: null,
  userAgentClientHintsEnabled: 0,
  botFiltersMode: 0,
  sendCustomConversionMode: 'all',
  sendCustomConversionIds:[],
  flowInline: {
    rules: [{
      name: 'Default',
      default: true,
      conditions: {},
      status: 'active',
      paths: [
        {
          name: 'Path 1',
          weight: 100,
          status: 'active',
          redirectMode: '302',
          redirectDomain: '',
          directLinking: false,
          landings: <any[]> [],
          offers: <any[]> []
        }
      ]
    }]
  }
} as Bemob.Campaign);
